var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.colors.length > 0)?_c('div',{staticClass:"d-flex flex-wrap"},_vm._l((_vm.filteredColors),function(color){return _c('div',{key:color.id,staticClass:"mr-2 mb-2"},[_c('label',{staticClass:"d-inline-flex align-items-center justify-content-center rounded-circle",style:({
        width: _vm.size + 'px',
        height: _vm.size + 'px',
        cursor: _vm.disabled ? 'cursor-not-allowed' : 'pointer',
        padding: '2px',
        boxSizing: 'border-box'
      }),attrs:{"title":color.description}},[_c('input',{staticClass:"sr-only",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"value":color,"checked":_vm.isSelected(color)},on:{"change":function($event){return _vm.toggleColor(color)}}}),_c('div',{class:{ 'opacity-50 cursor-not-allowed': _vm.disabled },style:(_vm.colorStyle(color))})])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }